import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {DxButtonModule} from 'devextreme-angular/ui/button';
import { ButtonComponent } from './button.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';


  @NgModule({
  declarations: [ButtonComponent],
  imports: [CommonModule, DxButtonModule, FontAwesomeModule],
  exports: [ButtonComponent]
})
export class ButtonModule {
  constructor(library: FaIconLibrary) {
  library.addIconPacks(fas);
}
}

